import { SHELF_EXPERIMENT_ID } from 'src/components/common/StatsigExposure/StatsigExposure'
import { Statsig } from 'src/sdk/statsig'

import BlueProductFlagDesktopIcon from '../../../Icons/BlueProductFlagDesktopIcon'
import BlueProductFlagMobileIcon from '../../../Icons/BlueProductFlagMobileIcon'
import BlueProductTechnologyIcon from '../../../Icons/BlueProductTechnologyIcon'

type BlueProductFlagProps = {
  style: 'flag' | 'badge'
  className?: string
  hideFlagOnMobile?: boolean
  flagWidth?: number
  flagHeight?: number
}

const BlueProductFlag = (props: BlueProductFlagProps) => {
  const { style = 'flag', className = '', hideFlagOnMobile = true } = props

  const isExperimentalVitrine =
    Statsig.useStatsigFeatureGateValue(SHELF_EXPERIMENT_ID)

  if (style === 'flag') {
    return (
      <>
        <BlueProductFlagMobileIcon
          className={`${
            hideFlagOnMobile ? 'hidden' : 'block'
          } sm:hidden ${className}`}
        />

        {isExperimentalVitrine ? (
          <BlueProductFlagDesktopIcon
            className={`hidden sm:block ${className}`}
            width={135}
            height={50}
          />
        ) : (
          <BlueProductFlagDesktopIcon
            className={`hidden sm:block ${className}`}
          />
        )}
      </>
    )
  }

  return (
    <div className={`bg-blueProductSurface p-4 my-6 ${className}`}>
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <BlueProductTechnologyIcon className="text-blueProductIcon" />
          <span className="text-[13px] leading-[21px] font-semibold text-black">
            Melhor custo benefício
          </span>
        </div>
        <p className="text-xs leading-[18px] font-normal text-black">
          Este produto foi escolhido pelo nosso time de especialistas por
          oferecer o melhor entre tecnologia, desempenho, qualidade e preço.
        </p>
      </div>
    </div>
  )
}

export default BlueProductFlag
